import { render } from "./FischBuchEintragPatentrevier.vue?vue&type=template&id=6293dd22&scoped=true&ts=true"
import script from "./FischBuchEintragPatentrevier.vue?vue&type=script&lang=ts"
export * from "./FischBuchEintragPatentrevier.vue?vue&type=script&lang=ts"

import "./FischBuchEintragPatentrevier.vue?vue&type=style&index=0&id=6293dd22&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6293dd22"]])

export default __exports__